import { defineComponent as _defineComponent } from 'vue'
import { BIconX } from "bootstrap-vue";
import { Dictionary } from "vue-router/types/router";
import useStore from "@/store/useStore";
import { useRoute, useRouter } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'time-travel-badge',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

function resetTimeTravel() {
  let query = store.copyAndModifyObject(route.query, [], ["at"]);
  router.push({
    name: route.name ? route.name : undefined,
    params: route.params,
    query: query as Dictionary<string>,
  });
}

return { __sfc: true,store, route, router, resetTimeTravel, BIconX }
}

})